import { useAuthStore } from '../stores/authStore';

interface PermissionGateProps {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function PermissionGate({ permission, children, fallback = null }: PermissionGateProps) {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  return hasPermission(permission) ? <>{children}</> : <>{fallback}</>;
}

interface AdminGateProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function AdminGate({ children, fallback = null }: AdminGateProps) {
  const isAdmin = useAuthStore((s) => s.isAdmin);
  return isAdmin() ? <>{children}</> : <>{fallback}</>;
}

/** Zeigt children wenn User EINE der angegebenen Permissions hat (Admin-Bypass via hasPermission). */
interface AnyPermissionGateProps {
  permissions: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function AnyPermissionGate({ permissions, children, fallback = null }: AnyPermissionGateProps) {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const allowed = permissions.some((p) => hasPermission(p));
  return allowed ? <>{children}</> : <>{fallback}</>;
}
